




















import { Component, Vue } from 'vue-property-decorator'
import { updateInfo } from '@/apis/myInfo/myInfo.ts'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import i18n from '@/lang';

@Component({})
export default class TeacherStudentStno extends Vue {
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  private title: string = ''
  private stnoNumber: any = this.userInfo.stno
  private warnInfo: string = '0'
  private warnOn: boolean = false //控制警示信息显隐
  // 监听输入
  change() {
    
  }
  keep() {
    if (this.stnoNumber.length < 2 && this.stnoNumber.length > 0) {
      this.warnInfo = i18n.t('ktpMy.请输入正确的') + this.title
      this.warnOn = true
    } else if (this.stnoNumber.length == 0) {
      this.warnInfo = this.title + i18n.t('ktpMy.不能为空')
      this.warnOn = true
    } else {
      //进行保存操作

      updateInfo({
        username: this.userInfo.username,
        school: this.userInfo.school,
        department: this.userInfo.department,
        teachcourse: this.userInfo.teachcourse,
        stno: this.stnoNumber,
        majors: this.userInfo.majors,
        classno: this.userInfo.additionInfo!.classno,
        enrolltime: this.userInfo.additionInfo!.enrolltime,
        grade: this.userInfo.additionInfo!.grade,
      })
        .then((res) => {
          this.$store.dispatch('setUserInfo').then(() => {
            this.$router.back()
          })
        })
        .catch((e) => {})
    }
  }
  created() {
    if (this.userInfo.usertype == '1') {
      this.title = i18n.t('ktpMy.教工号') as string
      this.$setNavInfo({
        type: 'normal',
        title: this.title,
        showTitle: true,
      })
    } else {
      this.title = i18n.t('Home.学号') as string
      this.$setNavInfo({
        type: 'normal',
        title: this.title,
        showTitle: true,
      })
    }
  }
}
